import {useIntl} from 'react-intl';

import {useThemeTypeToGlobal} from '@time-webkit/all/hooks/use_theme_type_to_global';

import ruGuideStep1Dark from 'images/notifications/guide-step-1_ru_dark.svg';
import ruGuideStep1Light from 'images/notifications/guide-step-1_ru_light.svg';
import ruGuideStep2Dark from 'images/notifications/guide-step-2_ru_dark.svg';
import ruGuideStep2Light from 'images/notifications/guide-step-2_ru_light.svg';

import enGuideStep1Dark from 'images/notifications/guide-step-1_en_dark.svg';
import enGuideStep1Light from 'images/notifications/guide-step-1_en_light.svg';
import enGuideStep2Dark from 'images/notifications/guide-step-2_en_dark.svg';
import enGuideStep2Light from 'images/notifications/guide-step-2_en_light.svg';

const guideImagesMap = {
    ru: {
        dark: [
            ruGuideStep1Dark,
            ruGuideStep2Dark,
        ],
        light: [
            ruGuideStep1Light,
            ruGuideStep2Light,
        ],
    },
    en: {
        dark: [
            enGuideStep1Dark,
            enGuideStep2Dark,
        ],
        light: [
            enGuideStep1Light,
            enGuideStep2Light,
        ],
    },
} as const;

export const useNotificationsGuideData = () => {
    const globalThemeType = useThemeTypeToGlobal();
    const {locale, formatMessage} = useIntl();

    const title = formatMessage({
        id: 'user.settings.notifications.guide.title',
        defaultMessage: 'Allow notifications in your phone Settings',
    });

    const step1 = formatMessage({
        id: 'user.settings.notifications.guide.step_1',
        defaultMessage:
            'Open the Settings in your phone and select the Notifications section',
    });

    const step2 = formatMessage({
        id: 'user.settings.notifications.guide.step_2',
        defaultMessage: 'Allow Time to send notifications',
    });

    const action = formatMessage({
        id: 'user.settings.notifications.guide.action',
        defaultMessage: 'Okay',
    });

    const back = formatMessage({
        id: 'user.settings.notifications.guide.back',
        defaultMessage: 'Back',
    });

    let imageSrcs = guideImagesMap.en[globalThemeType];

    if (locale === 'ru') {
        imageSrcs = guideImagesMap.ru[globalThemeType];
    }

    return {
        texts: {
            title,
            step1,
            step2,
            action,
            back,
        },
        imageSrcs,
    } as const;
};
